import * as React from 'react';

export interface Props {
	url: string,
	text: string
}

const ButtonLink = function(props:Props)  {
	return (
		<div className="cmp-redirect-element ">
			<a href={props.url} className='light-blue-button btn font-source-sans font-bold'>
				{props.text}
			</a>
		</div>
	)
};

export default ButtonLink;
